import Vendors from './Vendors.js';
export default Vendors;
